module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-10-89e06ab755e6c427a36a23f85a3888b7.jpg";